/**
 * AboutUsSection - Company description for public homepage
 */
const AboutUsSection = () => {
    return (
        <section className="bg-background border-t border-border/50">
            <div className="container mx-auto max-w-lg px-6 pt-12 pb-20 text-center">
                <h2 className="text-xl font-semibold tracking-tight text-foreground mb-5">
                    About Us
                </h2>
                <p className="text-base text-muted-foreground leading-relaxed mb-6">
                    Pinpoint Edu builds decision intelligence for learning. We help students achieve better outcomes per hour of study by precisely identifying knowledge gaps and ranking practice by expected impact. Powered by advanced AI and optimization algorithms, our platform delivers personalized, zero-waste learning paths—so every question, explanation, and minute of effort is focused on what matters most.
                </p>
                <p className="text-base text-muted-foreground/70">
                    Questions or partnerships? Contact us at{' '}
                    <a
                        href="mailto:yangmu@pinpointedu.com"
                        className="underline underline-offset-2 hover:text-foreground transition-colors"
                    >
                        yangmu@pinpointedu.com
                    </a>
                </p>
            </div>
        </section>
    );
};

export default AboutUsSection;
